import { Theme, css } from '@emotion/react';

export const giftCardBalanceRoot = ({ spacing, typography, breakpoints }: Theme) => css`
  margin-left: ${spacing(-2)}px;
  margin-right: ${spacing(-2)}px;
  margin-top: ${typography.pxToRem(-42)}px;
  ${breakpoints.up('sm')} {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
  }
`;

export const giftCardBalanceHeader = ({ spacing, colors, breakpoints }: Theme) => css`
  background-color: ${colors.bgLight};
  padding-top: ${spacing(3)}px;
  padding-bottom: ${spacing(18)}px;
  ${breakpoints.up('md')} {
    padding-bottom: ${spacing(12)}px;
  }
`;

export const giftCardBalanceContainer = ({ spacing }: Theme) => css`
  margin-top: ${spacing(3)}px;
`;

export const giftCardBalanceAmount = ({ spacing, breakpoints }: Theme) => css`
  margin-top: ${spacing(-18)}px;
  ${breakpoints.up('md')} {
    margin-top: ${spacing(-12)}px;
  }
`;

export const giftCardBalanceCard = () => css`
  border-radius: 0;
`;

export const giftCardBalanceAmountContent = ({ spacing, breakpoints }: Theme) => css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${spacing(1)}px;
  &:last-child {
    padding-bottom: ${spacing(4)}px;
  }
  ${breakpoints.up('md')} {
    flex-direction: row;
  }
`;

export const giftCardBalanceAccountNumber = ({ spacing, colors, breakpoints }: Theme) => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-top: 1px solid ${colors.borderDefault};
  flex: 1;
  padding-top: ${spacing(2)}px;
  ${breakpoints.up('md')} {
    border-left: 1px solid ${colors.borderDefault};
    border-top: 0;
    padding-left: ${spacing(3)}px;
    padding-top: 0;
  }
`;

export const giftCardBalanceBalance = ({ spacing, breakpoints }: Theme) => css`
  flex: 1;
  padding-bottom: ${spacing(2)}px;
  ${breakpoints.up('md')} {
    flex: 2;
    padding-bottom: 0;
  }
`;

export const giftCardBalanceExploreButton = ({ spacing, colors, breakpoints }: Theme) => css`
  margin: ${spacing(1)}px;
  ${breakpoints.up('md')} {
    border-top: 1px solid ${colors.borderDefault};
    padding-top: ${spacing(3)}px;
  }
`;
